export default __webpack_public_path__ + "static/dacha-reputation-7-3639f90607b0eecb7308b94677fc112f.png";